import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase/app';

import { Speaker } from '../../core/models/speaker';
import { ProfileForThisEvent } from '../../core/models/profileForThisEvent';
import { ProfileImageUpload } from '../../core/models/profile-image-upload';
import { SpeakerService } from '../../core/services/speaker.service';
import { ProfileInfo } from '../../core/models/profile-info';
import { TextBoxComponent } from '../../layout/text-box/text-box.component';
import { NewPageList } from '../../core/models/new-page-list';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants';
import { ContentsMandatory } from '../../core/models/contents-mandatory';

@Component({
  selector: 'app-speaker-profile',
  templateUrl: './speaker-profile.component.html',
  styleUrls: ['./speaker-profile.component.css'],
  providers: [SpeakerService, ExtraService, NewPageService]
})

export class SpeakerProfileComponent {

  // @ViewChild('textBox', { read: ViewContainerRef }) template: ViewContainerRef;
  @ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

  pageTitle: string = 'Add Speaker Profile';
  pageAlias: string = 'speakers-form';
  disableButton: boolean = true;

  isProfileImageVisible: boolean = false;
  eventID: string;
  speakerId: string;
  imageUrl: string = '';
  validEmailId: boolean;

  nameClass: string;
  emailClass: string;
  phoneClass: string;

  errorMessage: string[];
  isError: boolean = false;
  confirmMessage: string = '';

  currentFileUpload: ProfileImageUpload;
  imageFile: File = null;
  progress: { percentage: number } = { percentage: 0 }
  uploadComplete: number;

  speaker = new Speaker();
  profileForThisEvent1 = new ProfileForThisEvent();
  emailList: Array<any> = new Array();
  currentSpeakerEmail: string = '';
  log(event: boolean) {
    console.log(`Accordion has been ${event ? 'opened' : 'closed'}`);
  }


  constructor(private newPageService: NewPageService, private _cfr: ComponentFactoryResolver, private extraService: ExtraService,
    private router: Router, private route: ActivatedRoute, private speakerService: SpeakerService) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.newPageService.remove$.subscribe(data => {
      if (data != null) {
        let index = this.speaker.profile.aboutList.indexOf(data);
        //console.log(index);
        if (index != -1) {
          this.remove(index)
        }
      }
    });
    this.route.queryParams.subscribe(params => {
      let id = params['eventId'];
      let speakerId = params['speakerId'];
      if (params['eventId'] && !params['speakerId']) {
        this.eventID = params['eventId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.setEmailList(params['eventId']);
      } if (params['eventId'] && params['speakerId']) {
        this.eventID = params['eventId'];
        this.speakerId = params['speakerId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.setEmailList(params['eventId']);
        this.setSpekerDetails(params['eventId'], params['speakerId']);
      }
      //this.addTextBox();
    });
    this.newPageService.up$.subscribe(data => {
      if (data != null) {
        let index = this.profileForThisEvent1.aboutList.indexOf(data);
        if (index > 0) {
          this.swap(index, index - 1);
        }
      }
    });
    this.newPageService.down$.subscribe(data => {
      if (data != null) {
        let index = this.profileForThisEvent1.aboutList.indexOf(data);
        if (index < this.profileForThisEvent1.aboutList.length - 1) {
          this.swap(index, index + 1);
        }
      }
    });
    this.newPageService.remove$.subscribe(data => {
      if (data != null) {
        let index = this.profileForThisEvent1.aboutList.indexOf(data);
        //console.log(index);
        if (index != -1) {
          this.remove(index)
        }
      }
    });
  }

  showDropDown() {
    let aboutUs = new NewPageList();
    var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    var expComponent = this.dropDown.createComponent(dropDown);
    this.profileForThisEvent1.aboutList.push(aboutUs);
    expComponent.instance.eventId = this.eventID;
    expComponent.instance.show = false;
    expComponent.instance._ref = expComponent;
    expComponent.instance.aboutUs = this.profileForThisEvent1.aboutList[this.profileForThisEvent1.aboutList.length - 1];
  }

  addComponent(about: NewPageList) {
    var dropDown = this._cfr.resolveComponentFactory(DropDownComponent);
    var expComponent = this.dropDown.createComponent(dropDown);
    expComponent.instance.eventId = this.eventID;
    expComponent.instance._ref = expComponent;
    expComponent.instance.aboutUs = about;
    if (about.type == 'text') {
      expComponent.instance.addTextBox();
    } else if (about.type == 'list') {
      expComponent.instance.addList();
    } else {
      expComponent.instance.addStatic(about.type);
    }
  }

  swap(index1, index2) {
    this.dropDown.move(this.dropDown.get(index1), index2);
    let data = this.profileForThisEvent1.aboutList[index1];
    this.profileForThisEvent1.aboutList[index1] = this.profileForThisEvent1.aboutList[index2];
    this.profileForThisEvent1.aboutList[index2] = data;
  }
  remove(index) {
    this.profileForThisEvent1.aboutList = this.profileForThisEvent1.aboutList.filter((val, i) => i != index);
  }

  setEmailList(id) {
    this.speakerService.getEmailList(id).subscribe(event => {
      if (event) {
        for (let key in event) {
          this.emailList.push(event[key].email);
        }
      }
    });
  }

  setSpekerDetails(eventId, speakerId) {
    this.speakerService.getSingleSpeakerProfile(eventId, speakerId).subscribe(item => {

      if (item) {
        this.speaker = item;
        this.currentSpeakerEmail = item.email;
        this.profileForThisEvent1 = this.speaker.profile;
        if (this.profileForThisEvent1.aboutList) {
          this.profileForThisEvent1.aboutList.forEach(element => {
            this.addComponent(element);
          });
        } else {
          this.profileForThisEvent1.aboutList = new Array();
        }

        if (this.profileForThisEvent1.profileImageUri) {
          this.imageUrl = this.profileForThisEvent1.profileImageUri;
        }

      }
    });
  }

  onBasicUpload(event) {
    this.imageFile = event.files[0];
    console.log(this.imageFile);
    //this.currentFileUpload = event.files[0];
  }

  deleteProfileImage() {
    //console.log("delete");
    this.imageFile = null;
    this.isProfileImageVisible = false
  }

  deleteSpeakerFile() {
    //this.speakerService.deleteFileStorage(this.profileForThisEvent1, this.eventID, this.speakerId);
  }

  submit() {
    //this.addTextBox();
    this.disableButton = false;
    this.confirmMessage = null;
    this.isError = false;
    this.clearClasses();
    this.errorMessage = new Array();

    if (this.validate()) {
      if (this.speakerId == null) {
        if (this.imageFile != null) {
          //this.profileForThisEvent1.fileName = this.imageFile.name;
          this.currentFileUpload = new ProfileImageUpload(this.imageFile);
          let uploadTask = this.speakerService.pushUpload(this.currentFileUpload, this.eventID);
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
              this.confirmMessage = "File Uploading...";
              this.uploadComplete = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100)
            },
            (error) => {
              this.errorMessage.push(error.message);
              this.isError = true;
              this.disableButton = true;
            },
            () => {

              let contentsMandatory = new ContentsMandatory();
              contentsMandatory.category = Constants.CONTENT_M_TYPE_SPEAKERS;
              contentsMandatory.eventId = this.eventID;
              contentsMandatory.filename = this.imageFile.name;
              contentsMandatory.extension = this.imageFile.name.split('.').pop();
              contentsMandatory.sizeInBytes = this.imageFile.size;
              contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
              let key = this.speakerService.addContentMandatory(contentsMandatory);
              if (key) {

                //upload success
                this.confirmMessage = "File Uploaded successfully";
                setTimeout(function () { this.confirmMessage = null; }.bind(this), 1000);
                this.profileForThisEvent1.fileCMId = key;
                this.profileForThisEvent1.profileImageUri = uploadTask.snapshot.downloadURL
                this.profileForThisEvent1.updatedAtImage = new Date().getTime();
                this.profileForThisEvent1.updatedAt = new Date().getTime();
                this.profileForThisEvent1.email = this.speaker.email;
                this.speaker.profile = this.profileForThisEvent1;

                let speakerKey = this.speakerService.addSpeakerDetails(this.speaker, this.eventID);
                this.imageFile = null;
                this.confirmMessage = "Added successfully";
                if (this.uploadComplete == 100) {
                  setTimeout(function () {
                    this.confirmMessage = null;
                    this.disableButton = true;
                    this.router.navigate([Constants.SPEAKER_FORM, this.eventID]);
                  }.bind(this), 2000);
                }
              }

            }
          );
        } else {
          this.profileForThisEvent1.updatedAt = new Date().getTime();
          this.profileForThisEvent1.email = this.speaker.email;
          this.speaker.profile = this.profileForThisEvent1;
          let speakerKey = this.speakerService.addSpeakerDetails(this.speaker, this.eventID);
          if (speakerKey) {
            this.confirmMessage = "Speaker Added successfully";
            setTimeout(function () {
              this.confirmMessage = null;
              this.disableButton = true;
              this.router.navigate([Constants.SPEAKER_FORM, this.eventID]);
            }.bind(this), 2000);
          }
        }
      } else {
        if (this.speakerId != null && this.imageFile != null) {
          // this.profileForThisEvent1.fileName = this.imageFile.name;
          this.currentFileUpload = new ProfileImageUpload(this.imageFile);
          let uploadTask = this.speakerService.pushUpload(this.currentFileUpload, this.eventID);
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
              this.confirmMessage = "File Uploading...";
              this.uploadComplete = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100)
            },
            (error) => {
              this.disableButton = true;
              this.errorMessage.push(error.message);
              this.isError = true;
            },
            () => {

              let contentsMandatory = new ContentsMandatory();
              contentsMandatory.category = Constants.CONTENT_M_TYPE_SPEAKERS;
              contentsMandatory.eventId = this.eventID;
              contentsMandatory.filename = this.imageFile.name;
              contentsMandatory.extension = this.imageFile.name.split('.').pop();
              contentsMandatory.sizeInBytes = this.imageFile.size;
              contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
              let key = this.speakerService.addContentMandatory(contentsMandatory);
              if (key) {

                //upload success
                this.confirmMessage = "File Uploaded successfully";
                setTimeout(function () { }.bind(this), 1000);

                this.profileForThisEvent1.fileCMId = key;
                this.profileForThisEvent1.profileImageUri = uploadTask.snapshot.downloadURL
                this.profileForThisEvent1.updatedAtImage = new Date().getTime();
                this.profileForThisEvent1.updatedAt = new Date().getTime();
                this.profileForThisEvent1.email = this.speaker.email;
                this.speaker.profile = this.profileForThisEvent1;

                this.speakerService.updateSpeakerDetails(this.speaker, this.eventID, this.speakerId).then(res => {
                  this.imageFile = null;
                  this.confirmMessage = 'Speaker Update Successfully';
                  setTimeout(function () {
                    this.confirmMessage = null;
                    this.disableButton = true;
                    this.router.navigate([Constants.SPEAKER_FORM, this.eventID]);
                  }.bind(this), 2000);
                }).catch(error => {
                  this.disableButton = true;
                  this.errorMessage = error.message;
                });

              }

            }
          );
        } else {
          this.profileForThisEvent1.updatedAt = new Date().getTime();
          this.profileForThisEvent1.email = this.speaker.email;
          this.speaker.profile = this.profileForThisEvent1;
          this.speakerService.updateSpeakerDetails(this.speaker, this.eventID, this.speakerId).then(res => {
            console.log("res",res);
            this.imageFile = null;
            this.confirmMessage = 'Speaker Update Successfully';
            setTimeout(function () {
              this.confirmMessage = null;
              this.disableButton = true;
              this.router.navigate([Constants.SPEAKER_FORM, this.eventID]);
            }.bind(this), 2000);
          }).catch(error => {
            this.disableButton = true;
            this.errorMessage = error.message;
          });
        }
      }
    }
    else {
      this.isError = true;
      this.disableButton = true;
    }

  }

  validateEmail() {
    let valid = true;
    this.isError = false;
    this.errorMessage = new Array();
    this.clearClasses();

    let emailRex = "[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}";

    // if (this.speaker.email == null || this.speaker.email.trim().length < 1) {
    //   this.isError = true;
    //   valid = false;
    //   this.errorMessage.push("Email can not be empty");
    //   this.emailClass = "form-control fieldWithErrors";
    // } else 

    if (this.speaker.email && !this.speaker.email.match(emailRex)) {
      this.isError = true;
      valid = false;
      this.errorMessage.push('Email is not Valid');
      this.emailClass = 'form-control fieldWithErrors';
    } else {
      if (!this.speakerId && this.speaker.email.match(emailRex)) {
        let index = this.emailList.indexOf(this.speaker.email);
        if (index == -1) {
          this.isError = false;
          valid = true;
          this.emailClass = 'form-control';
        } else {
          this.isError = true;
          valid = false;
          this.errorMessage.push('Email already exists.');
          this.emailClass = 'form-control fieldWithErrors';
        }
      } else if (this.speaker.email == this.currentSpeakerEmail) {
        this.isError = false;
        valid = true;
        this.emailClass = 'form-control';
      } else if (this.speakerId && this.speaker.email.match(emailRex)) {
        let index = this.emailList.indexOf(this.speaker.email);
        if (index == -1) {
          this.isError = false;
          valid = true;
          this.emailClass = 'form-control';
        } else {
          this.isError = true;
          valid = false;
          this.errorMessage.push('Email already exists.');
          this.emailClass = 'form-control fieldWithErrors';
        }
      }
    }
    return valid;
  }

  validate() {
    let valid = true;
    // let emailRex = "[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}";
    this.profileForThisEvent1.aboutList.forEach(element => {
      if (element.type == 'text' && (element.text == null || element.text.trim().length < 1)) {
        if (this.errorMessage.indexOf('Text cannot empty') == -1) {
          this.errorMessage.push('Text cannot empty');
        }
        valid = false;
      }
      if (element.type == 'list' && (element.listWithinListList == null || element.listWithinListList.length < 1)) {
        if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
          this.errorMessage.push('Add atleast one list item');
        }
        valid = false;
      } else if (element.type == 'list' && element.listWithinListList.length == 1 && element.listWithinListList[0].hasSubList == null) {
        if (this.errorMessage.indexOf('Add atleast one list item') == -1) {
          this.errorMessage.push('Add atleast one list item');
        }
        valid = false;
      } else if (element.type == 'list' && element.listWithinListList != null && element.listWithinListList.length > 0) {
        element.listWithinListList.forEach(subList => {
          let bool = this.validateList(subList);
          if (!bool) {
            valid = false;
          }
        });
      }
      if (element.type == null || element.type.trim().length < 1) {
        this.remove(this.profileForThisEvent1.aboutList.indexOf(element));
      }

    });

    if (!this.profileForThisEvent1.name || this.profileForThisEvent1.name.trim().length < 1) {
      console.log(this.profileForThisEvent1.name, 'pankaj');
      this.isError = true;
      valid = false;
      this.nameClass = 'form-control fieldWithErrors';
      this.errorMessage.push('Name can\'t be empty');
    }

    // if (this.speaker.email == null || this.speaker.email.trim().length < 1) {
    //   this.isError = true;
    //   valid = false;
    //   this.emailClass = 'form-control fieldWithErrors';
    //   this.errorMessage.push('Email can not be empty');
    // }

    if ((this.profileForThisEvent1.phoneNo != null && this.profileForThisEvent1.phoneNo.replace('\""/g', '').length > 0 && !this.profileForThisEvent1.phoneNo.match('[6-9]{2}[0-9]{8}'))) {
      this.isError = true;
      valid = false;
      this.errorMessage.push('Phone.No not valid');
      this.phoneClass = 'form-control fieldWithErrors';
    }

    return valid;

  }

  validateList(listWithinList: ListWithinList): boolean {
    let valid = true;

    if ((listWithinList.hasSubList != null && (listWithinList.text == null || listWithinList.text.length < 1))) {
      if (this.errorMessage.indexOf('list field cannot empty') == -1) {
        this.errorMessage.push('list field cannot empty');
      }
      valid = false;
    }
    if (listWithinList.hasSubList && listWithinList.listWithinListList != null && listWithinList.listWithinListList.length > 0) {
      listWithinList.listWithinListList.forEach(subList => {
        valid = this.validateList(subList);
      });
    }
    return valid;
  }

  clearClasses() {
    this.nameClass = "form-control";
    this.emailClass = "form-control";
    this.phoneClass = "form-control";
  }
}







// WEBPACK FOOTER //
// /app/src/app/event/speaker-profile/speaker-profile.component.ts